import { CASES_ENDPOINT } from "../config";
import { createInstance } from "./createInstance";
const instance = createInstance(CASES_ENDPOINT);
export default instance;
